/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeLanguage } from './CodeLanguage';
import {
    CodeLanguageFromJSON,
    CodeLanguageFromJSONTyped,
    CodeLanguageToJSON,
    CodeLanguageToJSONTyped,
} from './CodeLanguage';
import type { ProblemType } from './ProblemType';
import {
    ProblemTypeFromJSON,
    ProblemTypeFromJSONTyped,
    ProblemTypeToJSON,
    ProblemTypeToJSONTyped,
} from './ProblemType';
import type { CompetitionSummary } from './CompetitionSummary';
import {
    CompetitionSummaryFromJSON,
    CompetitionSummaryFromJSONTyped,
    CompetitionSummaryToJSON,
    CompetitionSummaryToJSONTyped,
} from './CompetitionSummary';

/**
 * Response of GET /judge/problems/{id}, the only one that carries the solution.
 * 
 * `solution_code` and `extra_code` are None unless the caller owns the problem or holds the
 * administrator, content creator or competition organizer role.
 * @export
 * @interface ProblemDetail
 */
export interface ProblemDetail {
    /**
     * 
     * @type {string}
     * @memberof ProblemDetail
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetail
     */
    ordinal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetail
     */
    statement: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetail
     */
    points: number;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetail
     */
    time_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetail
     */
    complexity?: number | null;
    /**
     * Whether problem is publicly visible (True) or private (False)
     * @type {boolean}
     * @memberof ProblemDetail
     */
    is_public?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetail
     */
    owner_id?: string | null;
    /**
     * 
     * @type {ProblemType}
     * @memberof ProblemDetail
     */
    problem_type: ProblemType;
    /**
     * 
     * @type {CodeLanguage}
     * @memberof ProblemDetail
     */
    solution_language: CodeLanguage;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetail
     */
    id: string;
    /**
     * All test cases of the problem
     * @type {number}
     * @memberof ProblemDetail
     */
    test_cases_count?: number;
    /**
     * Test cases with the example visibility
     * @type {number}
     * @memberof ProblemDetail
     */
    example_count?: number;
    /**
     * Test cases whose official output is prepared (initialized)
     * @type {number}
     * @memberof ProblemDetail
     */
    prepared_test_cases_count?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProblemDetail
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<CompetitionSummary>}
     * @memberof ProblemDetail
     */
    competitions?: Array<CompetitionSummary>;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetail
     */
    solution_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetail
     */
    extra_code?: string | null;
}



/**
 * Check if a given object implements the ProblemDetail interface.
 */
export function instanceOfProblemDetail(value: object): value is ProblemDetail {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('statement' in value) || value['statement'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('problem_type' in value) || value['problem_type'] === undefined) return false;
    if (!('solution_language' in value) || value['solution_language'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ProblemDetailFromJSON(json: any): ProblemDetail {
    return ProblemDetailFromJSONTyped(json, false);
}

export function ProblemDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProblemDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'statement': json['statement'],
        'points': json['points'],
        'time_limit': json['time_limit'] == null ? undefined : json['time_limit'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'owner_id': json['owner_id'] == null ? undefined : json['owner_id'],
        'problem_type': ProblemTypeFromJSON(json['problem_type']),
        'solution_language': CodeLanguageFromJSON(json['solution_language']),
        'id': json['id'],
        'test_cases_count': json['test_cases_count'] == null ? undefined : json['test_cases_count'],
        'example_count': json['example_count'] == null ? undefined : json['example_count'],
        'prepared_test_cases_count': json['prepared_test_cases_count'] == null ? undefined : json['prepared_test_cases_count'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'competitions': json['competitions'] == null ? undefined : ((json['competitions'] as Array<any>).map(CompetitionSummaryFromJSON)),
        'solution_code': json['solution_code'] == null ? undefined : json['solution_code'],
        'extra_code': json['extra_code'] == null ? undefined : json['extra_code'],
    };
}

export function ProblemDetailToJSON(json: any): ProblemDetail {
    return ProblemDetailToJSONTyped(json, false);
}

export function ProblemDetailToJSONTyped(value?: ProblemDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ordinal': value['ordinal'],
        'statement': value['statement'],
        'points': value['points'],
        'time_limit': value['time_limit'],
        'complexity': value['complexity'],
        'is_public': value['is_public'],
        'owner_id': value['owner_id'],
        'problem_type': ProblemTypeToJSON(value['problem_type']),
        'solution_language': CodeLanguageToJSON(value['solution_language']),
        'id': value['id'],
        'test_cases_count': value['test_cases_count'],
        'example_count': value['example_count'],
        'prepared_test_cases_count': value['prepared_test_cases_count'],
        'tags': value['tags'],
        'competitions': value['competitions'] == null ? undefined : ((value['competitions'] as Array<any>).map(CompetitionSummaryToJSON)),
        'solution_code': value['solution_code'],
        'extra_code': value['extra_code'],
    };
}

